"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modules = void 0;
var modules_1 = require("./modules");
Object.defineProperty(exports, "Modules", { enumerable: true, get: function () { return __importDefault(modules_1).default; } });
